<div class="inspector-iscontained box-none" id="box-inspector">
    <div #container class="tw-box-comparison-boxes">
        <!-- lines -->
        <div
            [hidden]="!openRef || !openTar"
            *ngFor="let match of links"
            [ngStyle] = "{'z-index': 10000, 'left.px': match.left, 'top.px': match.top, 'width.px': match.width, 'transform':'rotate('+match.rotate+'rad)'}"
            class="lines">
        </div>

        <!-- LEFT COLUMN -->
        <div #content1 class="status-wrapper-text left-col">
            <header >
                <h3>Reference</h3>
            </header>
            <core-helpers-box-loading *ngIf="!loadRef"></core-helpers-box-loading>
            <div class="loader" [hidden]="!loadRef">
                <div class="loader-align">
                    <figure
                    #figure1
                    (scroll)="onRefScroll($event)"
                    class="tw-img-reference">
                        <div
                        [ngStyle]="{'transform': 'scale(' + refZoom + ')', 'transform-origin': '0 0', 'transition': 'transform 0.01s ease', 'will-change': 'transform'}"
                        coreSizeMe
                        [monitorHeight]="true"
                        [state]="refSize"
                        (resize)="refResize($event)" class="inspector-main">
                            <div  class="inspector-content">
                                <plugin-apollo-helpers-content-result-mark
                                *ngFor="let rmark of inspectorCtrl.marks.ref"
                                (click)="selectRefMark(rmark)"
                                [mark]="rmark"
                                [selected]="inspectorCtrl.isSelectedMark(rmark)"
                                [hidden]="!isFilterActive(rmark) || !openRef"></plugin-apollo-helpers-content-result-mark>
                            </div>
                            <img
                            [src]="inspectorCtrl.refImageSrc"
                            (load)="refImageLoad($event)"
                            alt="reference {{inspectorCtrl.refPage}}"
                            />
                        </div>
                    </figure>
                    <div *ngIf="inspectorCtrl.selectRefWord != null" class="font-inspector-info {{inspectorCtrl.selectRefWord.change}}">
                        <div class="marker-info"  [hidden]="inspectorCtrl.selectRefWord.styles.length == 0">
                            <ul>
                                <li *ngFor="let style of inspectorCtrl.selectRefWord.styles">
                                    <span [hidden]="style.text == inspectorCtrl.selectRefWord.text" class="letter">({{style.text}}) </span>
                                    <span class="name">{{style.font_name}}</span>,
                                    <span class="size">{{style.size}}pt</span>,
                                    <span class="weight">{{style.font_weight}}w</span>
                                    <span [hidden]="style.font_italicangle == 0" class="italic">, italic</span>
                                </li>
                            </ul>
                        </div>
                        <div class="marker-box">
                        <div class="marker-txt">{{inspectorCtrl.selectRefWord.text}}</div>
                        </div>
                    </div>
                <!--  <div *ngIf="refSelectedMark == null" class="font-inspector-info not_ap">
                    <div>Choose a marker to see the change details</div>
                </div> -->
                </div>
            </div>
            <div class="zoom-buttons" [hidden]="!loadRef">
                <div>
                    <span [ngClass]="{'disabled': refZoom >= MAX_ZOOM }" title="Zoom In" (click)="onRefZoom(0.1)" >
                        <em><strong>+</strong></em>
                    </span>
                    <span [ngClass]="{'disabled': refZoom <= MIN_ZOOM }" title="Zoom Out" (click)="onRefZoom(-0.1)">
                        <em><strong>-</strong></em>
                    </span>
                </div>
            </div>
        </div>
        <!-- END LEFT COLUMN -->
        <!-- RIGHT COLUMN -->
        <div #content2 class="status-wrapper-text right-col">
            <header>
                <h3>Target</h3>
            </header>
            <core-helpers-box-loading [hidden]="loadTar"></core-helpers-box-loading>
            <div class="loader" [hidden]="!loadTar">
                <div class="loader-align">
                    <figure
                    #figure2
                    (scroll)="onTarScroll($event)"
                    class="tw-img-reference"
                    >
                        <div
                        [ngStyle]="{'transform': 'scale(' + tarZoom + ')', 'transform-origin': '0 0', 'transition': 'transform 0.01s ease', 'will-change': 'transform'}"
                        coreSizeMe
                        [monitorHeight]="true"
                        [state]="targetSize"
                        (resize)="targetResize($event)" class="inspector-main">
                            <div  class="inspector-content">
                                <plugin-apollo-helpers-content-result-mark
                                *ngFor="let tmark of inspectorCtrl.marks.tar"
                                (click)="selectTarMark(tmark)"
                                [mark]="tmark"
                                [selected]="inspectorCtrl.isSelectedMark(tmark)"
                                [hidden]="!isFilterActive(tmark) || !openTar"></plugin-apollo-helpers-content-result-mark>
                            </div>
                            <img
                            [src]="inspectorCtrl.tarImageSrc"
                            (load)="tarImageLoad($event)"
                            alt="target {{inspectorCtrl.tarPage}}"
                            />
                        </div>
                    </figure>
                    <div *ngIf="inspectorCtrl.selectTarWord != null" class="font-inspector-info {{inspectorCtrl.selectTarWord.change}}">
                        <div class="marker-info"  >
                          <div class="arrows">
                            <a href="javascript:void(0)" class="previous-match" title="Previous Match" (click)="prevMatch()" [hidden]="!hasMatch.prev"></a>
                            <span class="cnt-match" [hidden]="position.total == 0"><em>{{position.current}}/{{position.total}}</em></span>
                            <a href="javascript:void(0)" class="next-match" title="Next Match" (click)="nextMatch()" [hidden]="!hasMatch.next"></a>
                        </div>

                            <ul [hidden]="inspectorCtrl.selectTarWord.styles.length == 0">
                                <li *ngFor="let style of inspectorCtrl.selectTarWord.styles">
                                    <span [hidden]="style.text == inspectorCtrl.selectTarWord.text" class="letter">({{style.text}}) </span>
                                    <span class="name">{{style.font_name}}</span>,
                                    <span class="size">{{style.size}}pt</span>,
                                    <span class="weight">{{style.font_weight}}w</span>
                                    <span [hidden]="style.font_italicangle == 0" class="italic">, italic</span>
                                </li>
                            </ul>
                        </div>
                        <div class="marker-box">
                        <div class="marker-txt">
                          <span class="match-accepted" *ngIf="isApprovedStatus(1)">Match <strong>accepted </strong><em></em></span>
                          <span class="match-rejected" *ngIf="isApprovedStatus(2)">Match <strong>rejected </strong><em></em></span>
                          {{inspectorCtrl.selectTarWord.text}}
                        </div>
                        <div class="switch-matches">
                          <div class="with-check">
                            <form>
                            <label for="all" class="checklabel"><em><strong></strong>All equal matches</em>
                              <input type="checkbox" [(ngModel)]="approvedAll" id="all"  [ngModelOptions]="{standalone: true}"/><span class="checkmark"></span>
                            </label>
                            </form>
                          </div>
                            <div class="buttons-fieldset">
                            <button *ngIf="!isApprovedStatus(0)" (click)="approvalMatch(0, approvedAll)" title="Reset Match" class="Reset-Match-Button">Reset</button>
                            <button *ngIf="isApprovedStatus(0) && !hasMatch.next" (click)="approvalMatch(1, approvedAll)" title="Accept Match" class="Accept-Match-Button">Accept</button>
                            <button *ngIf="isApprovedStatus(0) && hasMatch.next" (click)="approvalMatch(1, approvedAll)" title="Accept Match" class="Accept-Match-Button">Accept and next</button>
                            <button *ngIf="isApprovedStatus(0)" (click)="approvalMatch(2, approvedAll)" title="Reject Match" class="Reject-Match-Button">Reject</button>
                            </div>
                        </div>
                        </div>
                    </div>
                    <!-- <div *ngIf="tarSelectedMark == null" class="font-inspector-info not_ap">
                        <div>Choose a marker to see the change details</div>
                    </div> -->
                </div>
            </div>
            <div class="zoom-buttons" [hidden]="!loadTar">
                <div>
                    <span [ngClass]="{'disabled': tarZoom >= MAX_ZOOM }" title="Zoom In"  (click)="onTarZoom(0.1)">
                        <em><strong>+</strong></em>
                    </span>
                    <span [ngClass]="{'disabled': tarZoom <= MIN_ZOOM }" title="Zoom Out"  (click)="onTarZoom(-0.1)">
                        <em><strong>-</strong></em>
                    </span>
                </div>
            </div>
        </div>
        <!-- END RIGHT COLUMN -->
    </div>
</div>
